import { useState } from "react";
import { Button, Col, Modal, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import {
	update,
	updateCargaSelecionada,
	updateCarga_Id,
	updateEmbalagensList,
	updateProdutosList,
	updateRomaneiosList,
} from "../../redux/slicers/user";
import { updateTable } from "../../services/Servicos";

import "./Modal.scss";
import {
	danfeController,
	fotosController,
	removeProduto,
} from "../../redux/slicers/carga";

export default function ModalFinalizarEntrega({
	msg,
	title,
	show,
	setShow,
	cargas_id,
	processo,
	downloadDanfes = () => {},
}) {
	const dispatch = useDispatch();
	const carga_selecionada = useSelector(
		(state) => state.userSlice.cargaSelecionada
	);

	const handlerSimpleClose = () => setShow(false);
	const [loading, setLoading] = useState({
		flag: false,
		msg: "Confirmar",
		style: "primary",
	});
	const [data, setData] = useState(null);

	const confirmarInicio = async () => {
		const data = new Date();
		setData(data);
		let body = {
			[processo]: data.toISOString(),
		};

		try {
			setLoading({
				flag: true,
				msg: "Atualizando...",
				style: "warning",
			});

			for await (let carga of carga_selecionada) {
				dispatch(
					update({
						processo_entrega: {
							flag: false,
							locations: [],
						},
					})
				);
				let status = 13;

				if (carga.regiao_entrega == "LOCAL") {
					status = 15;
				}

				await updateTable(
					"cargas/motorista/update-carga-finalizar-entrega",
					carga.id,
					{ data_chegada: new Date(), status }
				);
			}

			dispatch(updateCargaSelecionada([]));
			dispatch(updateCarga_Id(null));
			dispatch(updateRomaneiosList([]));
			dispatch(updateProdutosList([]));
			dispatch(updateEmbalagensList([]));
			dispatch(removeProduto([]));
			dispatch(
				danfeController({
					action: "removeAll",
				})
			);
			dispatch(
				fotosController({
					action: "delete-all",
				})
			);

			setLoading({
				flag: false,
				msg: "Enviado",
				style: "success",
			});

			setTimeout(() => {
				window.location.replace("/dashboard");
			}, 1500);
		} catch (error) {}
	};

	return (
		<>
			<Modal
				show={show}
				onHide={handlerSimpleClose}
				backdrop="static"
				keyboard={false}
				centered
				size="md"
			>
				<Modal.Header closeButton>
					<Modal.Title>{title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{msg}
					<br></br>
					<p style={{ margin: 0 }}>
						<b>Data: {data?.toLocaleDateString("pt-BR")}</b>
					</p>
					<p style={{ margin: 0 }}>
						<b>Hora: {data?.toLocaleTimeString("pt-BR")}</b>
					</p>
				</Modal.Body>
				<Modal.Footer>
					<Col>
						<Button
							variant={loading.style}
							onClick={confirmarInicio}
							disabled={!loading.style.includes("primary")}
						>
							{loading.msg}
							{loading.flag ? (
								<Spinner animation="border" color="black" size="sm" />
							) : (
								""
							)}
							{loading.style === "success" ? (
								<i className="bi bi-check"></i>
							) : (
								""
							)}
						</Button>
					</Col>
					<Col>
						<Button variant="secondary" onClick={handlerSimpleClose}>
							Fechar
						</Button>
					</Col>
				</Modal.Footer>
			</Modal>
		</>
	);
}
